/**
 * Password Field Controller
 * Handles show/hide password toggle
 */

export class PasswordField {
  private input: HTMLInputElement | null = null
  private toggleBtn: HTMLButtonElement | null = null
  private isVisible: boolean = false

  constructor(element: HTMLElement) {
    this.input = element.querySelector('input')
    this.toggleBtn = element.querySelector('[data-toggle-btn]')

    this.init()
  }

  private init(): void {
    this.toggleBtn?.addEventListener('click', () => this.toggle())
  }

  public toggle(): void {
    if (!this.input) return

    this.isVisible = !this.isVisible
    this.input.type = this.isVisible ? 'text' : 'password'

    if (this.toggleBtn) {
      this.toggleBtn.setAttribute(
        'aria-label',
        this.isVisible ? 'Скрыть пароль' : 'Показать пароль'
      )
      this.toggleBtn.classList.toggle('is-password-visible', this.isVisible)
    }
  }
}
